import React, { useState, useContext, useEffect, useRef } from 'react';
import { GridStatusBGColors } from '../../../../../constants/Enums';
import moment from 'moment';
import { AsNumber, Spacer, IconEdit, IconDelete, useModal, ScrollbarSvg } from '@adserve/adserve-react-components';
import { SystemSettingsContext } from '../../../../../contexts/SystemSettingsContext';
import { AirtimePlanningContext } from '../../../../../contexts/AirtimePlanningContext';
import AsDatePicker from '../../../../generic/adserve-react-components/AsDatePicker/DatePicker';
import {
    DeletePropertySelectionById,
    GetPropertiesStats,
    GetPropertyStats,
    GetPropertyTotals
} from '../../../../../services/CampaignsDataService';
import { LoadPropertyDealPrice } from '../../../../../services/CampaignsDataService';

import { RedirectURL } from '../../../../../constants/Endpoint';

const inputWeeksStyle = {
    boxSizing: 'border-box',
    width: '100%',
    height: 37,
    outline: 'none',
    autoComplete: 'off',
    padding: '0 2px',
    fontSize: 15,
    letterSpacing: -0.3,
    fontWeight: 600,
    textAlign: 'center'
};
const datePickerButtonStyle = {
    height: 37,
    width: 32,
    marginLeft: -3
};

const inputStyle = {
    boxSizing: 'border-box',
    backgroundColor: '#FFFDF4',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500,
    padding: '10px 0px 11px 7px',
    borderRadius: 5,
    height: 37
};

const SelectedPropertyRowNew = ({
    bodyCellStyle,
    alternateColour,
    dataStyle,
    openProperty,
    readOnly,
    bookedReadOnly,
    selectedProperty,
    deleteProperty,
    handleNameClick,
    propertyCostingTypes,
    recalcTotals,
    campaign,
    updateWinPrice,
    dealStationPrices,
    formatLaydown,
    currentCampaignVersionId,
    isRunning,
    isCompleted
}) => {
    const { formatCurrency, dateFormat, formatNumber } = useContext(SystemSettingsContext);
    const { propertyStats, setPropertyStats } = useContext(AirtimePlanningContext);
    const [highlighted, setHighlighted] = useState(false);
    const [priceRender, setPriceRender] = useState(0);
    const { addMessage } = useModal();

    const reachPct = () => {
        return 100 * (selectedProperty?.reach / selectedProperty?.population);
    };

    const updateProperty = (prop) => {
        campaign.modified = true;
        setPropertyStats([...propertyStats]);
        recalcTotals();
    };
    const resetStats = () => {
        selectedProperty.reach = 0;
        selectedProperty.scheduledSpotCount = 0;
        selectedProperty.liveSpotCount = 0;
        selectedProperty.impacts = 0;
        selectedProperty.partnerAirtimeCount = 0;
        selectedProperty.featureCount = 0;
    };
    const handleFromDateChange = (event) => {
        let val = moment(event.target.value).utc(true).startOf('day');
        resetStats();
        const newSelectedProperty = selectedProperty;
        if (dateFormat === 'DD MMM YYYY') {
            if (val.length >= 11) {
                val = moment(val, dateFormat);
                if (val.isValid()) {
                    val = val.toDate();
                }
            }
        }
        if (dateFormat === 'DD/MM/YYYY' || dateFormat === 'MM/DD/YYYY') {
            if (val.length >= 10) {
                val = moment(val, dateFormat);
                if (val.isValid()) {
                    val = val.toDate();
                }
            }
        }
        if (dateFormat === 'DD/MM/YY' || dateFormat === 'MM/DD/YY') {
            if (val.length >= 8) {
                val = moment(val, dateFormat);
                if (val.isValid()) {
                    val = val.toDate();
                }
            }
        }
        if (dateFormat === 'DD MMM YY') {
            if (val.length >= 9) {
                val = moment(val, dateFormat);
                if (val.isValid()) {
                    val = val.toDate();
                }
            }
        }
        if (
            newSelectedProperty.sandPPropertyTypeName === 'Ongoing' ||
            newSelectedProperty.sandPPropertyTypeName === 'OngoingTwoWeek'
        ) {
            const now = moment().utc(true).startOf('day');
            if (now.isAfter(val)) {
                val = now;
            }
        }
        if (
            newSelectedProperty.sandPPropertyTypeName === 'Ongoing' ||
            newSelectedProperty.sandPPropertyTypeName === 'OngoingTwoWeek'
        ) {
            if (val.day() !== 1) {
                addMessage({
                    message: window.translate(
                        'Please choose a Monday starting today or later as the Start Date to cover the full week'
                    ),
                    buttons: [
                        {
                            text: window.translate('OK'),
                            style: { cursor: 'pointer' },
                            callback: null
                        }
                    ]
                });
                return;
            }
        }
        newSelectedProperty.startDate = val.toISOString();

        if (newSelectedProperty.sandPPropertyTypeName === 'OngoingTwoWeek') {
            const ongoingTwoWeekEnd = moment(val).add(2, 'weeks').subtract(1, 'days').day(0).set('hour', 1);
            newSelectedProperty.endDate = ongoingTwoWeekEnd.toISOString();
        }
        if (
            newSelectedProperty?.propertyDurationType === 2 ||
            newSelectedProperty?.propertyDurationType === 'Ongoing'
        ) {
            if (newSelectedProperty?.weeks) {
                const ongoingTwoWeekEnd = moment(val)
                    .add(selectedProperty?.weeks, 'weeks')
                    .subtract(1, 'days')
                    .day(0)
                    .set('hour', 1);
                newSelectedProperty.endDate = ongoingTwoWeekEnd.toISOString();
            }
        }

        updateProperty(newSelectedProperty);
    };

    const handleEndDateChange = (event, idx) => {
        let endDate = moment(event.target.value).utc(true).startOf('day');
        if (endDate.day() !== 0) {
            addMessage({
                message: window.translate('Please choose a Sunday as the End Date to cover the full week'),
                buttons: [
                    {
                        text: window.translate('OK'),
                        style: { cursor: 'pointer' },
                        callback: null
                    }
                ]
            });
            return;
        }
        const newSelectedProperty = selectedProperty;
        resetStats();
        const startDate = moment(newSelectedProperty.startDate).utc(true).startOf('day');
        newSelectedProperty.endDate = endDate.toISOString();
        let weeks = endDate.diff(startDate, 'weeks') + 1;
        if (!weeks) weeks = 1;
        newSelectedProperty.weeks = weeks;
        const now = moment().utc(true).startOf('day');
        if (now.isAfter(endDate)) {
            endDate = now;
        }
        updateProperty(newSelectedProperty);

        //        updatepropertyPrices(undefined, endDate, idx);
    };

    const UpdateSelectedProperty = (prop) => {
        campaign.modified = true;
        setPropertyStats([...propertyStats]);
    };

    const handleWeeksChange = (v, id) => {
        const newSelectedProperty = selectedProperty;
        newSelectedProperty.noOfweeksChanged = newSelectedProperty?.weeks != v;
        const prevWeeks = getWeeks();
        newSelectedProperty.weeks = v;
        selectedProperty.weeks = v;
        newSelectedProperty.endDate = moment(selectedProperty?.startDate)
            .add(v, 'weeks')
            .subtract(1, 'days')
            .day(0)
            .set('hour', 1);
        campaign.modified = true;

        if (!newSelectedProperty?.id || newSelectedProperty?.id === window.emptyGuid) {
            newSelectedProperty.sandPBudget =
                (newSelectedProperty.sandPBudget / (prevWeeks && prevWeeks > 0 ? prevWeeks : 1)) * (v && v > 0 ? v : 1);
        }

        if (v) {
            newSelectedProperty.propertyListPrice =
                (selectedProperty?.propertyListPrice / (Number(prevWeeks) || 1)) * (Number(v) || 0) || 0;
            newSelectedProperty.propertyDealPrice =
                (selectedProperty?.propertyDealPrice / (Number(prevWeeks) || 1)) * (Number(v) || 0) || 0;
        } else {
            newSelectedProperty.propertyListPrice = selectedProperty?.propertyListPrice / (Number(prevWeeks) || 1) || 0;
            newSelectedProperty.propertyDealPrice = selectedProperty?.propertyDealPrice / (Number(prevWeeks) || 1) || 0;
        }
        UpdateSelectedProperty(newSelectedProperty);
        setPriceRender(priceRender + 1);
    };

    const handlePriceChange = (event, idx) => {
        const val = event.target.value;
        selectedProperty.sandPBudget = val;

        //selectedProperty.defaultSandPBudget = val / getWeeks();
        selectedProperty.propertyDealPrice = val;
        campaign.modified = true;
        UpdateSelectedProperty(selectedProperty);
    };

    const handleWeeksBlur = () => {
        updateProperty({ ...selectedProperty });
    };

    const getScheduledSpots = () => {
        return selectedProperty?.scheduledSpotCount + selectedProperty?.partnerAirtimeCount;
    };

    const getLiveSpots = () => {
        return selectedProperty?.liveSpotCount + selectedProperty?.featureCount;
    };

    const getImpacts = () => {
        return selectedProperty.impacts;
    };
    const getOTH = () => {
        if (!selectedProperty.reach) {
            return 0;
        }
        const oth = getImpacts() / selectedProperty.reach;
        return oth;
    };
    const calculatedListPrice = () => {
        return selectedProperty.listPrice;
    };
    const calculatedDealPrice = () => {
        return selectedProperty.dealPrice ?? 0;
    };
    const getWeeks = () => {
        if (!selectedProperty?.endDate || !selectedProperty?.startDate) {
            return '';
        }
        const days = moment(selectedProperty?.endDate).diff(moment(selectedProperty?.startDate), 'days');
        return Math.ceil((days + 1) / 7);
    };
    return (
        <tr
            key={`activeProperties${selectedProperty.id}`}
            style={{
                ...bodyCellStyle,
                backgroundColor: highlighted ? GridStatusBGColors.HIGHLIGHTED : alternateColour
            }}
            onMouseOver={() => setHighlighted(true)}
            onMouseLeave={() => setHighlighted(false)}
        >
            <td style={{ ...dataStyle, minWidth: 80, maxWidth: 80, padding: 'unset' }}>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <div style={{ width: 40, height: '100%', paddingTop: 7 }}>
                        <IconEdit
                            height={20}
                            width={20}
                            fill='#414141'
                            disabled={selectedProperty.id === window.emptyGuid || readOnly || bookedReadOnly}
                            onClick={() => openProperty(selectedProperty)}
                        />
                    </div>
                    <div style={{ width: 40, height: 32, borderLeft: '1px solid #D7D7D7', paddingTop: 7 }}>
                        <IconDelete
                            height={20}
                            width={20}
                            fill='#414141'
                            disabled={readOnly || bookedReadOnly}
                            onClick={() => deleteProperty(selectedProperty)}
                        />
                    </div>
                </div>
            </td>
            <td
                onClick={() => handleNameClick(selectedProperty)}
                style={{
                    ...dataStyle,
                    ...(selectedProperty.id === window.emptyGuid ? {} : { cursor: 'pointer', color: '#16009D' }),
                    minWidth: 220,
                    maxWidth: 220,
                    textAlign: 'left'
                }}
            >
                {selectedProperty?.name}
            </td>
            <td style={{ ...dataStyle, minWidth: 120, maxWidth: 120, textAlign: 'left' }}>
                {selectedProperty?.linkedStationNames}
            </td>
            <td style={{ ...dataStyle, minWidth: 120, maxWidth: 120, textAlign: 'left' }}>
                {selectedProperty?.propertyType}
            </td>
            <td style={{ ...dataStyle, minWidth: 120, maxWidth: 120 }}>
                {selectedProperty?.sandPPropertyTypeName !== 'Ongoing' &&
                selectedProperty?.sandPPropertyTypeName !== 'OngoingTwoWeek' &&
                !selectedProperty.dateChanged ? (
                    selectedProperty?.startDate ? (
                        moment(selectedProperty?.startDate).format(dateFormat)
                    ) : (
                        ''
                    )
                ) : (
                    <div style={{ width: 120, marginLeft: -8 }}>
                        <AsDatePicker
                            id={`ongoing-start-date-${selectedProperty.id}`}
                            inputStyle={inputStyle}
                            buttonStyle={datePickerButtonStyle}
                            currentDate={selectedProperty?.startDate}
                            minDate={
                                selectedProperty?.sandPPropertyTypeName === 'Ongoing' || selectedProperty.dateChanged
                                    ? moment().add('days', 1).utc(true).startOf('day')
                                    : undefined
                            }
                            onChange={(e) => handleFromDateChange(e)}
                            handleMultiple={true}
                            dateFormat={dateFormat}
                            disabled={readOnly || isRunning || isCompleted}
                            hideIcon={true}
                        />
                    </div>
                )}
            </td>
            <td style={{ ...dataStyle, minWidth: 60, maxWidth: 60 }}>
                {selectedProperty?.sandPPropertyTypeName === 2 ||
                selectedProperty?.sandPPropertyTypeName === 'Ongoing' ? (
                    <AsNumber
                        id={`week-count-${selectedProperty.id}`}
                        inputStyle={inputWeeksStyle}
                        value={getWeeks()}
                        onChange={(e) => handleWeeksChange(e?.target?.value, selectedProperty.id)}
                        onBlur={() => handleWeeksBlur()}
                        disabled={readOnly || isCompleted}
                        disallowNegatives={true}
                        allowFloat={false}
                        digitLimit={3}
                        formatNumber={formatNumber}
                    />
                ) : (
                    getWeeks()
                )}
            </td>
            <td style={{ ...dataStyle, minWidth: 120, maxWidth: 120 }}>
                {selectedProperty?.sandPPropertyTypeName !== 'Ongoing' ? (
                    selectedProperty?.endDate ? (
                        moment(selectedProperty?.endDate).format(dateFormat)
                    ) : (
                        ''
                    )
                ) : (
                    <div style={{ width: 120, marginLeft: -8 }}>
                        <AsDatePicker
                            id={`ongoing-end-date-${selectedProperty.id}`}
                            inputStyle={inputStyle}
                            buttonStyle={datePickerButtonStyle}
                            currentDate={selectedProperty?.endDate}
                            minDate={
                                selectedProperty.sandPPropertyTypeName === 'Ongoing'
                                    ? moment(selectedProperty?.startDate).utc(true).startOf('day')
                                    : undefined
                            }
                            onChange={(e) => handleEndDateChange(e)}
                            handleMultiple={true}
                            dateFormat={dateFormat}
                            disabled={readOnly || isCompleted}
                            hideIcon={true}
                        />
                    </div>
                )}
            </td>
            <td style={{ ...dataStyle, minWidth: 100, maxWidth: 100 }}>
                {selectedProperty?.noOfweeksChanged ? 0 : formatNumber(getScheduledSpots())}
            </td>
            <td style={{ ...dataStyle, minWidth: 100, maxWidth: 100 }}>
                {selectedProperty?.noOfweeksChanged ? 0 : formatNumber(getLiveSpots())}
            </td>
            <td style={{ ...dataStyle, minWidth: 80, maxWidth: 80 }}>
                {selectedProperty?.noOfweeksChanged
                    ? 0
                    : formatNumber(selectedProperty?.reach, { maximumFractionDigits: 0 })}
            </td>
            <td style={{ ...dataStyle, minWidth: 80, maxWidth: 80 }}>
                {' '}
                {selectedProperty?.noOfweeksChanged
                    ? 0
                    : formatNumber(isNaN(reachPct()) ? 0 : reachPct(), { maximumFractionDigits: 2 })}
            </td>
            <td style={{ ...dataStyle, minWidth: 80, maxWidth: 80 }}>
                {selectedProperty?.noOfweeksChanged ? 0 : formatNumber(getImpacts(), { maximumFractionDigits: 0 })}
            </td>
            <td style={{ ...dataStyle, minWidth: 70, maxWidth: 70 }}>
                {' '}
                {selectedProperty?.noOfweeksChanged ? 0 : formatNumber(getOTH(), { maximumFractionDigits: 1 })}
            </td>
            <td style={{ ...dataStyle, minWidth: 110, maxWidth: 110 }}>
                {formatCurrency(selectedProperty?.offAirCosts, { maximumFractionDigits: 0 })}
            </td>
            <td style={{ ...dataStyle, minWidth: 140, maxWidth: 140, textAlign: 'right' }}>
                {selectedProperty?.noOfweeksChanged
                    ? 0
                    : formatCurrency(calculatedListPrice(), { maximumFractionDigits: 0 })}
            </td>
            <td style={{ ...dataStyle, minWidth: 140, maxWidth: 140, textAlign: 'right' }}>
                {selectedProperty?.noOfweeksChanged
                    ? 0
                    : formatCurrency(calculatedDealPrice(), { maximumFractionDigits: 0 })}
            </td>
            <td style={{ ...dataStyle, minWidth: 130, maxWidth: 130, textAlign: 'right' }}>
                <div style={{ display: 'flex' }}>
                    <AsNumber
                        id={`minBudget${selectedProperty.id}`}
                        inputStyle={{
                            boxSizing: 'border-box',
                            height: 34,
                            width: 150,
                            outlineStyle: 'none',
                            autoComplete: 'off',
                            padding: '0 5px',
                            fontSize: 14,
                            fontWeight: 500,
                            border: '1px solid #D7D7D7'
                            // backgroundColor: readOnly ? alternateColour : i % 2 === 0 ? '#FFFAE5' : '#FBF7E1'
                        }}
                        disabled={readOnly || selectedProperty?.id === window.emptyGuid}
                        value={selectedProperty?.id !== window.emptyGuid ? selectedProperty.sandPBudget ?? 0 : 0}
                        allowFloat={true}
                        onChange={(e) => handlePriceChange(e)}
                        formatCurrency={formatCurrency}
                        size={9}
                    />
                </div>
            </td>
        </tr>
    );
};
export default SelectedPropertyRowNew;
